import { createAsyncThunk } from "@reduxjs/toolkit";

import { BasketApiImpl } from "../../api";

export const loadBasketThunk = createAsyncThunk("basket/load", async () =>
  BasketApiImpl.getInstance().load()
);
